import { intl } from "LocaleWrapper";
import { Select } from "@cofano/cck";
import { SelectProps } from "@cofano/cck/Select/Select";
import { RechargeBillingState } from "__generated__/enums";

const RechargeBillingStateSelect = ({
	...rest
}: Omit<SelectProps<RechargeBillingState, false>, "getOptionLabel" | "fetchOptions" | "paginated" | "disableSearch">) => (
	<Select
		{...rest}
		getOptionLabel={option => intl.formatMessage({ id: `RECHARGE_BILLING_STATE_${option}` })}
		fetchOptions={Object.values(RechargeBillingState)}
		disableSearch />
);

export default RechargeBillingStateSelect;
